export default __webpack_public_path__ + "static/media/PAFI_Announcement of GMS 2021.f52175a0.pdf";